import React from 'react';

//
const HelpRoutes = [
    // 首页
    {
        path: '/help/main',
        component: React.lazy(() => import('../../modules/help/help/List')),
    }
];

export {HelpRoutes};
